import type { PeriodsDiff } from '@/typings/Shipments/PeriodsDiff'

// Usage must use the exact same period, customer and distribution channel as delivery time.
export function withDeliveryAvailability(delivery: PeriodsDiff[], usage: PeriodsDiff[]): PeriodsDiff[] {
  const isZero = (value: unknown) => value !== null && value !== undefined && String(value).trim() !== '' && Number(value) === 0
  return delivery.map((row) => {
    const count = usage.find((item) => item.name === row.name)
    return {
      ...row,
      noCurrentShipments: !!count && isZero(count.currentPeriod) && isZero(row.currentPeriod),
      noPreviousShipments: !!count && isZero(count.previousPeriod) && isZero(row.previousPeriod),
    }
  })
}
